import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";
import { ContentAndStatus } from '../../Models/OtherClasses';

@Injectable()
export class ScheduleService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	) {
		this.url = urlService.getURL('Schedule');
	}

	
	loadForAllTrucks(date: Date): Observable<TooBig4Car.Logic.OverallTruckDateScheduleVM> {
		return this.myBaseService.getPlain(this.url + '/ForAllTrucks?date=' + this.myBaseService.getDateStr(date), 'Failed to load schedule');
	}
	loadForTruck(truckID: System.Guid, date: Date): Observable<ContentAndStatus<TooBig4Car.Logic.TruckDateScheduleVM>> {

		return this.myBaseService.getPlainErrorOptionWithStatusCode(this.url + '/ForTruck/' + truckID + '?date=' + this.myBaseService.getDateStr(date), 'Failed to load schedule', true);
	}

	save(obj: TooBig4Car.Logic.TruckDateScheduleVM, reCalcDistanceAndDriveTimes: boolean, sortPickups: boolean): Observable<TooBig4Car.Logic.TruckDateScheduleVM> {
		var iurl = this.url + '/ForTruck?reCalcDistanceAndDriveTimes=' + (reCalcDistanceAndDriveTimes || false).toString();
		iurl += '&sortPickups=' + (sortPickups || false).toString()
		return this.myBaseService.post(obj, iurl, true);
	}

	swap(obj: TooBig4Car.Logic.TruckSwapDateVM): Observable<TooBig4Car.Logic.TruckRouteSwapResult> {
		var iurl = this.url + '/Swap';
		return this.myBaseService.post(obj, iurl, true);
	}


	start(id: System.Guid, date: Date): Observable<TooBig4Car.Logic.TruckDateScheduleVM> {
		return this.myBaseService.post(null, this.url + '/Start/' + (id || '') + '?date=' + this.myBaseService.getDateStr(date), false);
	}

	stop(id: System.Guid, date: Date): Observable<TooBig4Car.Logic.TruckDateScheduleVM> {
		return this.myBaseService.post(null, this.url + '/Finish/' + (id || '') + '?date=' + this.myBaseService.getDateStr(date), false);
	}

	lock(id: System.Guid, date: Date): Observable<TooBig4Car.Logic.TruckDateScheduleVM> {
		return this.myBaseService.post(null, this.url + '/Lock/' + (id || '') + '?date=' + this.myBaseService.getDateStr(date), false);
	}

	unlock(id: System.Guid, date: Date): Observable<TooBig4Car.Logic.TruckDateScheduleVM> {
		return this.myBaseService.post(null, this.url + '/Unlock/' + (id || '') + '?date=' + this.myBaseService.getDateStr(date), false);
	}

	autoAssignTrucks(date: Date): Observable<TooBig4Car.Logic.OverallTruckDateScheduleVM> {
		return this.myBaseService.post(null, this.url + '/AutoAssign?date=' + this.myBaseService.getDateStr(date), true);
	}

	reshuffleTruck(truckID: System.Guid, date: Date): Observable<TooBig4Car.Logic.TruckDateScheduleVM> {
		return this.myBaseService.post(null, this.url + '/Reshuffle/' + (truckID ?? '') + '?date=' + this.myBaseService.getDateStr(date), true);
	}

	deleteBreak(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url + '/Break');
	}
}

